module.exports = __webpack_public_path__ + "static/media/extension.f342372d.md";